import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GoPlus } from "react-icons/go";
import { HiLightningBolt } from "react-icons/hi"; // Using standard icons, close match
import Button from "../../components/ui/Button";

const RoleSelectionPage = () => {
    const [selectedRole, setSelectedRole] = useState(null);
    const navigate = useNavigate();

    const handleContinue = () => {
        if (selectedRole === "brand") {
            navigate("/onboarding/brand");
        } else if (selectedRole === "creator") {
            navigate("/onboarding/creator");
        }
    };

    // Listen for Enter key
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Enter" && selectedRole) {
                handleContinue();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [selectedRole, handleContinue]);

    return (
        <div className="min-h-screen bg-[#fffcf8] flex flex-col p-6"> {/* Cream background */}

            {/* Header */}
            <div className="flex items-center gap-2 text-black font-bold text-xl mb-12">
                <img src="/logo.png" alt="Braccet" className="w-8 h-8 object-contain" />
                <span>Braccet</span>
            </div>

            <div className="flex-1 flex flex-col items-center max-w-4xl mx-auto w-full">
                <h1 className="text-3xl font-bold text-gray-900 mb-8 self-start md:self-center">Tell us who you are</h1>

                {/* Role Cards Container */}
                <div className="bg-[#F0F6FF] rounded-3xl p-4 md:p-8 w-full flex flex-col md:flex-row gap-4 mb-8">

                    {/* Brand Card */}
                    <button
                        onClick={() => setSelectedRole("brand")}
                        className={`flex-1 bg-white rounded-2xl p-8 flex flex-col items-center justify-center gap-4 py-12 transition-all border-2 ${selectedRole === "brand" ? "border-blue-600 shadow-md transform scale-105" : "border-transparent hover:shadow-sm"}`}
                    >
                        <div className="text-4xl text-gray-700 font-light mb-2">
                            <GoPlus />
                        </div>
                        <h3 className="text-xl font-bold text-gray-900">Brand</h3>
                        <p className="text-gray-500 text-sm">Get Started as a brand</p>
                    </button>

                    {/* Creator Card */}
                    <button
                        onClick={() => setSelectedRole("creator")}
                        className={`flex-1 bg-white rounded-2xl p-8 flex flex-col items-center justify-center gap-4 py-12 transition-all border-2 ${selectedRole === "creator" ? "border-blue-600 shadow-md transform scale-105" : "border-transparent hover:shadow-sm"}`}
                    >
                        <div className="text-4xl text-gray-700 font-light mb-2">
                            <HiLightningBolt />
                        </div>
                        <h3 className="text-xl font-bold text-gray-900">Creator</h3>
                        <p className="text-gray-500 text-sm">Get Started as a creator</p>
                    </button>
                </div>

                {/* Footer Actions */}
                <div className="w-full flex justify-between items-center mt-4">
                    {/* Removed max-w-md to align with the cards container or kept it? 
                         The user said "not aligned". 
                         The cards container is w-full (max-w-4xl). 
                         The buttons were max-w-md. This causes misalignment if the container is wider.
                         I will make buttons container match the width of the cards container.
                     */}
                    <div className="flex gap-4">
                        <Button variant="secondary" className="px-8 !rounded-xl bg-white border border-gray-200" onClick={() => navigate(-1)}>Back</Button>
                    </div>

                    <Button
                        variant="primary"
                        className={`px-8 !rounded-xl ${!selectedRole ? 'opacity-50 cursor-not-allowed' : ''}`}
                        onClick={handleContinue}
                        disabled={!selectedRole}
                    >
                        Continue
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default RoleSelectionPage;
